import { InputOwnerState, InputProps } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { SlotProps } from '@mui/joy/utils/types';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

import InputView from './InputView';
import InputWithControllerView from './InputWithControllerView';

interface IInputSlotProps {
  input?: SlotProps<'input', Record<string, unknown>, InputOwnerState>;
  startDecorator?: SlotProps<'span', Record<string, unknown>, InputOwnerState>;
  endDecorator?: SlotProps<'span', Record<string, unknown>, InputOwnerState>;
}

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface IInputProps extends Omit<InputProps, 'error'>, IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  label?: string | string[];
  tooltip?: string;
  required?: boolean;
  slotProps?: IInputSlotProps;
  showFieldError?: boolean;
  helperTexts?: string[] | JSX.Element[];
  helperTextSxProps?: SxProps;
}

export const Input = (props: IInputProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { setValue, getValues, ...other } = props;

  if (props?.control) {
    return <InputWithControllerView {...other} />;
  }

  return <InputView {...other} />;
};
